export default __webpack_public_path__ + "static/media/slam.c34f4128.png";